module.exports = __webpack_public_path__ + "img/product-euroblot.a7f0c325.jpg";